//import React, { useEffect, useState } from "react";
import React, { useEffect, useState, useRef } from "react";
import AppCtrl from "../../../control/AppCtrl";
import useAlert from "../../../hook/useAlert";
import useBetWin from "../../../redux/betWinData/betWinAction";
import useBoosting from "../../../redux/boosting/boostingAction";
import useBroadcasts from "../../../redux/broadcasts/broadcastsAction";
import useGameplay from "../../../redux/gameplay/gameplayAction";
import useScoreMsg from "../../../redux/scoreMsg/scoreMsgAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import ActionID from "../../../utils/ActionID";
import Config from "../../../utils/Config";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import EPage from "../../../utils/EPage";
import EFunction from "../../../utils/FunctionPage";
import LANGUAGE_TYPE from "../../../utils/Language";
import ScreenOrientation from "../../../utils/Orientation";
import RemoteServer from "../../../utils/RemoteServer";
import ScoringCmd from "../../../utils/ScoringCmd";
import Utils from "../../../utils/Utils";
import CryptoJS from "../../../utils/crypto-js.min";
import BetWinPanel from "../../BetWinPanel";
import GameBG from "../../GameBG";
import VideoPanel from "../../VideoPanel";
import styles from "./index.module.scss";
import { use } from "react";

const uiBtnHoldType = {
  LongPress: 0,
  Usual: 1,
  Pinpon: 2,
  LongPress_In1Sec: 3,
  Pinpon_In1Sec: 4,
};
const uiElements = {
  machine: {},
  others: {},
  btns: {},
};
const mGameBtns = {};
const mGameOthers = {};
let mSingleInScore = 100;
let mInScoreNum = 1;
let mScoreMsgTimeout = null;
let mCheckCheckReconnect = null;
let mVideoUINum = 0;
let mVideoUIIndex = 0;
let isTrunview = false;
let isFullscreenInBonusView = true;
let isKeyboardEnable = true;
let mbCreditInDisabled = false;
let mCreditInDisabledTimeout = null;
let mbCreditOutDisabled = false;
let mCreditOutDisabledTimeout = null;
let mCreditInThisTime = 0;
let mCredit = 0;
let mMSDisplayIndex = 0;
let mHereAnimation = null;
let mSpinAnimation = null;
let mTianjing = null;
let hdlUpdateBroadcast = null;
let mBroadcast = "";
// let mBroadcastsList = null;
// let iColorIndex = 0;
let iMsgIndex = 0;
let miBroadcastDistance = 0;
let mLastReloadTime = new Date(0);
let mCoinImg = "";
let bFirstTimeInMachine = false;
let ScaleW = 1;
let mLongPressID = null;
let mLongPress_In1SecID = null;
let shoBonusBtn = false;
let mMegeStateTitle = "";
let mMiniStateTitle = "";
let mBoosting = false;


function GamePlayClassic() {
  // 使用 useRef 存儲 protocol
  const protocolRef = useRef('http');
   // 1) 機器人模式：退出倒數狀態
  const robotExitTimerRef = useRef(null);
  const robotExitCountdownRef = useRef(0);
  const [robotExitCountdown, setRobotExitCountdown] = useState(null);
  // 機器人模式：自動按鍵
  const robotAutoTimerRef = useRef(null);        // 每 5 分鐘補按一次 0
  const robotLoopIntervalRef = useRef(null);     // 每 3 秒循環按 2..N（僅 type=0）
  const robotSeqIndexRef = useRef(0);
  const robotSeqTimeoutsRef = useRef([]);
  const robotPerBtnIntervalsRef = useRef({});    // type=3 每0.5秒專用
  const robotStartDelayRef = useRef(null);       // 新增：type=1/3 延遲啟動用
  const robotStartedRef = useRef(false);
  const gameBtnOrderRef = useRef([]);

  const { setFunc } = switchFunc();
  const [winABase, setWinABase] = useState(10);
  const [winBBase, setWinBBase] = useState(10);
  const [winAToBonus, setWinAToBonus] = useState(0);
  const [winBToBonus, setWinBToBonus] = useState(0);
  
  const { userCoins } = useUserCoins();
  const { gameplay } = useGameplay();
  const { betWinData, setHistoryTriggered, setWScale, setHScale, bonusState } =
    useBetWin();
  const { boosting } = useBoosting();
  const { broadcasts } = useBroadcasts();
  const { scoreMsg } = useScoreMsg();
  const { showAlert } = useAlert();

  const { bonusBroadcast } = useBroadcasts();

  const [isFirstMount, setIsFirstMount] = useState(true);

  const bgImgId = "machineBG";
  const defGameBtnStatusUP = 0;
  const defGameBtnStatusDOWN = 1;
  const defGameBtnStatusDOWN_HOLD = 2;
  const videoIds = [
    {
      id: "videoScreen0",
      iframe: "gameVideo",
    },
    {
      id: "videoScreen1",
      iframe: "gameVideo1",
    },
    {
      id: "videoScreen2",
      iframe: "gameVideo2",
    },
  ];
  const videoInfo = [];
  //===========================================================================
  // 在 useEffect 中更新 protocol
  useEffect(() => {
    const middleServer = AppCtrl.middleServer();
    if (middleServer && middleServer.getProtocol) {
      const currentProtocol = middleServer.getProtocol();
      if (currentProtocol) {
        protocolRef.current = currentProtocol;
      }
    }
  }, []);
  useEffect(() => {
    if(boosting)    {
      mBoosting = true;
      showAlert({ title: `客服代打中,有問題請詢問客服!!!` });
    }
    else {
      if(mBoosting != boosting){
        showAlert({ title: `客服結束代打中,有問題請詢問客服!!!` });
        mBoosting = false;
      }
    }
  },[boosting]);
  useEffect(() => {
    if (uiElements.others.hasOwnProperty("megastate")) {
      const uiMegastate = uiElements.others["megastate"];
      uiMegastate.innerHTML = `${mMegeStateTitle} : ${winAToBonus} / ${winABase}`;
    }
  }, [winABase]);
  useEffect(() => {
    if (uiElements.others.hasOwnProperty("ministate")) {
      const uiMinistate = uiElements.others["ministate"];
      uiMinistate.innerHTML = `${mMiniStateTitle} : ${winBToBonus} / ${winBBase}`;
    }
  }, [winBBase]);
  useEffect(() => {
    if (uiElements.others.hasOwnProperty("megastate")) {
      const uiMegastate = uiElements.others["megastate"];
      uiMegastate.innerHTML = `${mMegeStateTitle} : ${winAToBonus} / ${winABase}`;
    }
  }, [winAToBonus]);
  useEffect(() => {
    if (uiElements.others.hasOwnProperty("ministate")) {
      const uiMinistate = uiElements.others["ministate"];
      uiMinistate.innerHTML = `${mMiniStateTitle} : ${winBToBonus} / ${winBBase}`;
    }
  }, [winBToBonus]);

  useEffect(() => {
    shoBonusBtn = Config.showBonusBtn ? Config.showBonusBtn : false;
    componentDidMount();
    //2 進入機台後啟動機器人退出倒數
    if (AppCtrl.isRobotMode()) {
      startRobotExitCountdownIfNeeded();
    }
    setIsFirstMount(false);
    return () => {
      // 停止機器人倒數
      if (robotExitTimerRef.current) {
        clearInterval(robotExitTimerRef.current);
        robotExitTimerRef.current = null;
      }
      setRobotExitCountdown(null);
      // 停止機器人自動按鍵
      stopRobotAutoPlay();

      componentWillUnmount();
    }
  }, []);

  useEffect(() => {
    if (
      bonusBroadcast &&
      !isFirstMount &&
      bonusBroadcast.length > 0 &&
      !AppCtrl.checkBonusAccount()
    ) {
      const bMobileDevice = Utils.detectmob();
      const text = bonusBroadcast[0].Content;
      const uiBonusAlert = document.createElement("p");

      const fontSize = bMobileDevice ? "18px" : "24px";
      const padding = bMobileDevice ? "5px 10px" : "20px 40px";
      const letterSpacing = bMobileDevice ? "1px" : "3px";

      // 基本樣式 - 改為白底紅字
      uiBonusAlert.style.cssText = `
        background: linear-gradient(135deg, #ffffff, #f8f9fa);
        color: #dc3545;
        padding: ${padding};
        border-radius: 12px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1),
                    0 8px 25px rgba(0, 0, 0, 0.08);
        font-size: ${fontSize};
        font-weight: 700;
        text-align: center;
        letter-spacing: ${letterSpacing};
        position: fixed;
        left: 50%;
        bottom: -100%;
        transform: translateX(-50%) scale(0.8);
        white-space: normal;
        max-width: 95vw;
        word-wrap: break-word;
        border: 2px solid #dc3545;
        text-shadow: none;
        backdrop-filter: blur(5px);
        z-index: 9999;
        transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        opacity: 0;
      `;

      // 添加內容 - 改為紅色漸層文字
      uiBonusAlert.innerHTML = `
        <span style="
          background: linear-gradient(45deg, #dc3545, #ff4d5a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: 1.1em;
          display: inline-block; // 確保漸層效果在換行時正確顯示
        ">${text}</span>
      `;

      // 添加到頁面
      document.body.appendChild(uiBonusAlert);

      // 強制重繪以確保過渡效果生效
      uiBonusAlert.offsetHeight;

      // 進場動畫
      requestAnimationFrame(() => {
        uiBonusAlert.style.opacity = "1";
        uiBonusAlert.style.bottom = "50%";
        uiBonusAlert.style.transform = "translate(-50%, 50%) scale(1)";
      });

      // 添加浮動動畫
      setTimeout(() => {
        uiBonusAlert.style.animation = "float 2s ease-in-out infinite";
        const styleSheet = document.createElement("style");
        styleSheet.textContent = `
          @keyframes float {
            0%, 100% { transform: translate(-50%, 50%); }
            50% { transform: translate(-50%, calc(50% - 8px)); }
          }
        `;
        document.head.appendChild(styleSheet);
      }, 600);

      // 退場動畫
      setTimeout(() => {
        uiBonusAlert.style.bottom = "150%";
        uiBonusAlert.style.opacity = "0";
        uiBonusAlert.style.transform = "translate(-50%, -50%) scale(0.8)";
      }, 3500);

      // 移除元素
      setTimeout(() => {
        if (uiBonusAlert && uiBonusAlert.parentNode) {
          uiBonusAlert.parentNode.removeChild(uiBonusAlert);
        }
      }, 4500);
    }
  }, [bonusBroadcast]);

  useEffect(() => {
    const message = "抽獎通知";
    const subcontent = "參加抽獎條件已達成立即進行抽獎，如中獎會通知您與所有玩家，沒中獎則不另行通知 !!";
    const iconType = "";
    const showButton = true;
    const closetimer = 0;
    
    const buttonText = "OK";
    if( bonusState.bonusNote === "JoinLuckyDraw")
    {
      showAlert({
        title: message,
        text: subcontent,
        icon: iconType,
        showConfirmButton: showButton,
        confirmButtonText: buttonText,
        confirmCb: function () {
          resolve(true);
        },
      });
    }

    if (bonusState) {
      setWinABase(bonusState.winABase);
      setWinBBase(bonusState.winBBase);
      setWinAToBonus(bonusState.winAToBonus);
      setWinBToBonus(bonusState.winBToBonus);
    } else {
      setWinABase(10);
      setWinBBase(10);
      setWinAToBonus(0);
      setWinBToBonus(0);
    }


  }, [bonusState]);

  useEffect(() => {
    updateUserCoins(userCoins);
  }, [userCoins]);

  useEffect(() => {
    updateMsg(scoreMsg);
  }, [scoreMsg]);

  useEffect(() => {
    updateGameplay(gameplay);
  }, [gameplay]);

  useEffect(() => {
    updateBroadcasts(broadcasts);
  }, [broadcasts]);

  useEffect(() => {
    // Page Visibility API 監聽
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("網頁在背景執行");
        // 背景狀態下的邏輯，例如暫停某些操作
      } else {
        // const reload =
        //   betWinData?.betWinType != null && betWinData.betWinType !== 0;
        // if (reload) doReload();
        RestoreBtnState();
        console.log("網頁回到前景");
        // 回到前景時恢復操作
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    //清理函數：解除監聽
    return () => {
      componentWillUnmount();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // 一次點擊封裝
  function pressGameBtn(btnId) {
    const btn = mGameBtns[btnId];
    if (!btn) return;
    setGameBtnStatus(btnId, defGameBtnStatusDOWN);
    setTimeout(() => setGameBtnStatus(btnId, defGameBtnStatusUP), 200);
  }

  function runRobotSequenceOnce() {
    // 清掉前一次序列的 timeout
    robotSeqTimeoutsRef.current.forEach(clearTimeout);
    robotSeqTimeoutsRef.current = [];

    const ids = gameBtnOrderRef.current;
    if (!ids || ids.length === 0) return;

    // 依序從 index 2 開始到最後，每 3 秒按一次（完全跳過 index 1）
    // index: 0 = 加分鍵, 1 = 減分鍵(不使用), 2..N = 依序按
    let step = 0;
    for (let i = 2; i < ids.length; i++) {
      const id = ids[i];
      const t = setTimeout(() => pressGameBtn(id), step * 3000);
      robotSeqTimeoutsRef.current.push(t);
      step++;
    }
  }

  function startRobotAutoPlay() {
    if (robotStartedRef.current) return;

    const ids = gameBtnOrderRef.current;
    if (!AppCtrl.isRobotMode() || !ids || ids.length === 0) return;

    robotStartedRef.current = true;

    // 進入立即按一次 index=0（加分）
    const addBtnId = ids[0];
    pressGameBtn(addBtnId);

    // 準備 2..N（跳過 index=1），依 type 分流
    const blacklist = new Set(["exit", "reload", "history"]);
    const holdIds = [];     // type=1（保持按下，延遲3秒後開始）
    const pulseIds = [];    // type=3（每0.5秒按一下，延遲3秒後開始）
    const seqIds = [];      // type=0（參與3秒輪播，立即開始）

    for (let i = 2; i < ids.length; i++) {
      const id = ids[i];
      if (blacklist.has(id)) continue;

      const t = mGameBtns[id]?.RobotType ?? 0;
      if (t === 2) {
        continue; // 不按
      } else if (t === 1) {
        holdIds.push(id);
      } else if (t === 3) {
        pulseIds.push(id);
      } else {
        seqIds.push(id);
      }
    }

    // 啟動 3 秒循環（僅 type=0，立即開始）
    if (seqIds.length > 0) {
      robotSeqIndexRef.current = 0;
      if (robotLoopIntervalRef.current) clearInterval(robotLoopIntervalRef.current);
      robotLoopIntervalRef.current = setInterval(() => {
        if (!AppCtrl.isRobotMode()) return;
        const id = seqIds[robotSeqIndexRef.current];
        pressGameBtn(id);
        robotSeqIndexRef.current = (robotSeqIndexRef.current + 1) % seqIds.length;
      }, 3000);
    }

    // 每 5 分鐘額外補按一次 index=0（不影響 3 秒循環）
    if (robotAutoTimerRef.current) clearInterval(robotAutoTimerRef.current);
    robotAutoTimerRef.current = setInterval(() => {
      if (!AppCtrl.isRobotMode()) return;
      pressGameBtn(addBtnId);
    }, 5 * 60 * 1000);

    // 新增：type=1/3 延遲 3 秒後才開始
    if (robotStartDelayRef.current) {
      clearTimeout(robotStartDelayRef.current);
      robotStartDelayRef.current = null;
    }
    robotStartDelayRef.current = setTimeout(() => {
      if (!AppCtrl.isRobotMode() || !robotStartedRef.current) return;

      // 啟動保持按下（type=1）
      for (const id of holdIds) {
        const btn = mGameBtns[id];
        if (!btn || btn.btnStatus === defGameBtnStatusDOWN_HOLD) continue;
        setGameBtnStatus(id, defGameBtnStatusDOWN_HOLD);
      }

      // 啟動每0.5秒按一下（type=3）
      for (const id of pulseIds) {
        if (robotPerBtnIntervalsRef.current[id]) continue;
        robotPerBtnIntervalsRef.current[id] = setInterval(() => {
          if (!AppCtrl.isRobotMode()) return;
          pressGameBtn(id);
        }, 500);
      }

      robotStartDelayRef.current = null;
    }, 3000);
  }

  function stopRobotAutoPlay() {
    // 停止延遲啟動
    if (robotStartDelayRef.current) {
      clearTimeout(robotStartDelayRef.current);
      robotStartDelayRef.current = null;
    }

    // 停止 3 秒循環
    if (robotLoopIntervalRef.current) {
      clearInterval(robotLoopIntervalRef.current);
      robotLoopIntervalRef.current = null;
    }
    // 停止 5 分鐘補按
    if (robotAutoTimerRef.current) {
      clearInterval(robotAutoTimerRef.current);
      robotAutoTimerRef.current = null;
    }
    // 停止每0.5秒 type=3
    for (const id in robotPerBtnIntervalsRef.current) {
      clearInterval(robotPerBtnIntervalsRef.current[id]);
    }
    robotPerBtnIntervalsRef.current = { };

    // 釋放 type=1 的長按
    for (const id in mGameBtns) {
      const btn = mGameBtns[id];
      if (btn?.RobotType === 1 && btn.btnStatus === defGameBtnStatusDOWN_HOLD) {
        setGameBtnStatus(id, defGameBtnStatusUP);
      }
    }

    robotSeqTimeoutsRef.current.forEach(clearTimeout);
    robotSeqTimeoutsRef.current = [];
    robotStartedRef.current = false;
  }
  // ==============================
  //===========================================================================
  // 退出倒數工具
  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function formatCountdown(sec) {
    if (sec == null) return "";
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  function startRobotExitCountdownIfNeeded() {
    if (robotExitTimerRef.current) return;
    //startRobotExitCountdown(randInt(10, 45)); // 10~30 分
    startRobotExitCountdown(randInt(600, 1800)); // 10~30 分
  }
  function startRobotExitCountdown(seconds) {
    if (robotExitTimerRef.current) {
      clearInterval(robotExitTimerRef.current);
      robotExitTimerRef.current = null;
    }
    robotExitCountdownRef.current = seconds;
    setRobotExitCountdown(seconds);
    robotExitTimerRef.current = setInterval(async () => {
      const next = robotExitCountdownRef.current - 1;
      robotExitCountdownRef.current = next;
      setRobotExitCountdown(next);
      if (next <= 0) {
        clearInterval(robotExitTimerRef.current);
        robotExitTimerRef.current = null;
        try {
          await exitConfirmed();
        } catch (e) {
          console.error("auto-exit error:", e);
        }
      }
    }, 1000);
  }
  function componentDidMount() {
    const machineInfo = AppCtrl.machineInfo();
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    const uiMainArea = document.getElementById("mainArea");
    //Loading Gif
    if (uiMainArea) {
      const uiLoadingMask = document.createElement("img"); //new Image();
      uiLoadingMask.id = "loadingmask";
      uiLoadingMask.type = "image";
      uiLoadingMask.src = "img/ChooseMachine/Loading.gif";
      //uiLoadingMask.name = 'submit';
      uiLoadingMask.style.position = "absolute";
      uiLoadingMask.style.left = "50%";
      uiLoadingMask.style.top = "50%";
      uiLoadingMask.style.width = "100%";
      uiLoadingMask.style.height = "100%";
      uiLoadingMask.style.transform = "translate(-50%,-50%)";
      uiLoadingMask.style.display = "";
      uiMainArea.appendChild(uiLoadingMask);
      //音效移動動畫
      const uiUnMountHint = document.createElement("img"); //new Image();
      uiUnMountHint.id = "unMountHint";
      uiUnMountHint.type = "image";
      uiUnMountHint.src = "img/ChooseMachine/unMuteHint.gif";
      //uiUnMountHint.name = 'submit';
      uiUnMountHint.style.position = "absolute";
      uiUnMountHint.style.left = "50%";
      uiUnMountHint.style.top = "50%";
      uiUnMountHint.style.width = "100%";
      uiUnMountHint.style.height = "100%";
      uiUnMountHint.style.transform = "translate(-50%,-50%)";
      uiUnMountHint.style.display = "";
      uiMainArea.appendChild(uiUnMountHint);
    }
    const checkOrientation = AppCtrl.CheckOrientation();
    if (checkOrientation) {
      AppCtrl.SetOrientation(ScreenOrientation.LandscapePrimary);
    }

    isFullscreenInBonusView = AppCtrl.isFullscreenInBonusView();
    isKeyboardEnable = AppCtrl.isKeyboardEnable();
    mSingleInScore = machineInfo.singleInScore;
    isTrunview = false;
    buildGameUI(deviceWidth, deviceHeight, machineInfo.gameUI);
    registerEvent();

    videoInfo.splice(0, videoInfo.length);
    for (let i = 0; i < videoIds.length; i++) {
      const uiVideoFrame = document.getElementById(videoIds[i].id);
      if (uiVideoFrame)
        uiVideoFrame.style.display = i < mVideoUINum ? "" : "none";

      videoInfo.push({
        angle: machineInfo.videoInfos[i].rotate,
        cameraScale: machineInfo.videoInfos[i].scale,
        source: machineInfo.videoInfos[i].source,
        streamId: i + 1,
      });
    }
    mVideoUIIndex = 0;

    AppCtrl.setMachineTokenCB(() => {
      for (let i = 0; i < mVideoUINum; i++) {
        startVideo(i, videoInfo[i].source, videoInfo[i].angle);
      }
    });

    mMSDisplayIndex = 0;
    AppCtrl.setCookie("lobbyName", AppCtrl.lobbyName());
    AppCtrl.setCookie("machineName", AppCtrl.machineName());
    bFirstTimeInMachine = false;
    setTimeout(function () {
      AppCtrl.getUserScores();
    }, 1000);
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    const checkOrientation = AppCtrl.CheckOrientation();
    if (checkOrientation) {
      AppCtrl.FreeOrientation();
    }
    if (hdlUpdateBroadcast) {
      clearTimeout(hdlUpdateBroadcast);
      hdlUpdateBroadcast = null;
    }

    for (let i = 0; i < mVideoUINum; i++) {
      stopVideo(i);
    }
    unregisterEvent();
    // reset
    uiElements.machine = {};
    uiElements.others = {};
    uiElements.btns = {};

    setIsFirstMount(true);

    
  }

  

  function handleBonusBtnClick() {
    if((Config?.urlBonus?.trim() !== ""))
    {
      const bonusUrl = `${Config.urlBonus}/bonusClient/bonus`;
      const content = `<iframe src="${bonusUrl}" style="width:100%;border-width:0px;overflow-y:auto;height:100vh"></iframe>`;

      showAlert({
        html: content,
        showConfirmButton: true,
        fullscreen: true,
      });
    }
    
  }

  function intToString(value) {
    let strValue = "0";
    if (value) {
      let prefix = "";
      if (value < 0) {
        prefix = "-";
        value = -value;
      }
      let arrValue = [];
      while (value > 0) {
        arrValue.push(value % 1000);
        value = Math.floor(value / 1000);
      }
      if (arrValue.length > 0) arrValue.reverse();
      else arrValue.push(0);

      strValue = `${prefix}${arrValue[0]}`;
      for (let i = 1; i < arrValue.length; i++) {
        let value = arrValue[i];
        if (value === 0) strValue += `,000`;
        else if (value < 10) strValue += `,00${value}`;
        else if (value < 100) strValue += `,0${value}`;
        else strValue += `,${value}`;
      }
    }
    return strValue;
  }

  function RestoreBtnState() {
    let btnId = null;
    let gameBtn;
    for (let id in mGameBtns) {
      gameBtn = mGameBtns[id];
      btnId = id;
      if (btnId != null && gameBtn) {
        // game btn up
        switch (gameBtn.btnHoldType) {
          case uiBtnHoldType.LongPress: //長壓
            if (gameBtn.btnStatus === defGameBtnStatusDOWN_HOLD) {
              //原版如果是長壓,就先解除
              mLongPressID = btnId;
              setGameBtnStatus(btnId, defGameBtnStatusUP);
              //setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
              setTimeout(function () {
                //間隔1.5秒後再長壓
                setGameBtnStatus(mLongPressID, defGameBtnStatusDOWN_HOLD);
              }, 1500);
            }

            break;
          case uiBtnHoldType.LongPress_In1Sec: //1.5秒後長壓
            if (gameBtn.btnStatus === defGameBtnStatusDOWN_HOLD) {
              mLongPress_In1SecID = btnId;
              if (gameBtn.timeoutLongPressed) {
                //有的話先清除
                clearTimeout(gameBtn.timeoutLongPressed);
                gameBtn.timeoutLongPressed = null;
              }
              // cancel long press
              setGameBtnStatus(mLongPress_In1SecID, defGameBtnStatusUP);
              setTimeout(function () {
                //間隔1.5秒後再執行一秒長壓
                setGameBtnStatus(
                  mLongPress_In1SecID,
                  defGameBtnStatusDOWN_HOLD
                );
                // set timeoutLongPressed to check hold action
                if (gameBtn.timeoutLongPressed)
                  clearTimeout(gameBtn.timeoutLongPressed);
                gameBtn.timeoutLongPressed = setTimeout(function () {
                  gameBtn.timeoutLongPressed = null;
                }, 1000);
              }, 1500);
            }

            break;

          default:
            break;
        }
      }
    }
  }

  function enableCreditUIs(bEnable) {
    const uiCreditIn = document.getElementById("開分");
    const uiCreditOut = document.getElementById("洗分");
    const uiSelectScore = document.getElementById("selector");
    const uiReload = document.getElementById("reload");
    const uiExit = document.getElementById("exit");

    if (uiCreditIn) {
      uiCreditIn.style.opacity = bEnable ? 1 : 0.7;
      uiCreditIn.disabled = bEnable ? false : true;
    }
    if (uiCreditOut) {
      uiCreditOut.style.opacity = bEnable ? 1 : 0.7;
      uiCreditOut.disabled = bEnable ? false : true;
    }
    if (uiSelectScore) {
      uiSelectScore.style.opacity = bEnable ? 1 : 0.7;
      uiSelectScore.disabled = bEnable ? false : true;
    }
    if (uiReload) {
      uiReload.style.opacity = bEnable ? 1 : 0.7;
      uiReload.disabled = bEnable ? false : true;
    }
    if (uiExit) {
      uiExit.style.opacity = bEnable ? 1 : 0.7;
      uiExit.disabled = bEnable ? false : true;
    }
  }

  function onInScoreTimesChanged(select) {
    if (!select) return;

    const id = select.id;
    console.log(`id;${id}`);
    mInScoreNum = parseInt(select.value);

    const uiPoint = uiElements.others["point"];
    mCreditInThisTime = mInScoreNum * mSingleInScore; //intToString(mInScoreNum * mSingleInScore);
    if (uiPoint) uiPoint.innerHTML = intToString(mCreditInThisTime);
  }

  function updateUserCoins(userCoins) {
    const machine = AppCtrl.lockedMachine();
    let normalScore = 0;
    if (machine) {
      const wainZhus = userCoins.wainZhus;
      if (machine.isTrial) {
        if (AppCtrl.isUserOnGuoZhao()) {
          mCredit = userCoins.guoZhaoCoins;
          normalScore = userCoins.trialCoins;
        } else {
          mCredit = userCoins.trialCoins;
        }
      } else {
        if (AppCtrl.isUserOnGuoZhao()) {
          mCredit = userCoins.guoZhaoCoins;
          normalScore = userCoins.coins;
        } else {
          mCredit = userCoins.coins;
        }
      }

      const uiScore = uiElements.others["score"];
      if (uiScore) uiScore.innerHTML = intToString(mCredit);
      if (AppCtrl.isUserOnGuoZhao()) {
        const uiNormalScore = uiElements.others["normalscore"];
        if (uiNormalScore) {
          uiNormalScore.innerHTML = intToString(normalScore);
        }
      } else {
        const uiNormalScore = uiElements.others["normalscore"];
        if (uiNormalScore && uiNormalScore.style.display === "") {
          uiNormalScore.innerHTML = intToString(0);
          uiNormalScore.style.display = "none";
        }
        const uiNormalcoin = uiElements.others["normalcoin"];
        if (uiNormalcoin && uiNormalcoin.style.display === "") {
          uiNormalcoin.style.display = "none";
          const uiCoin = uiElements.others["coin"];
          if (uiCoin) {
            uiCoin.src = mCoinImg;
            const language = AppCtrl.getLanguage();
            let message;
            let buttonText;
            switch (language) {
              case LANGUAGE_TYPE.zh_TW:
                message = "請注意，已經取消過招";
                buttonText = "確認";
                break;
              case LANGUAGE_TYPE.en_US:
              default:
                message = "Notice: System Has Cancelled";
                buttonText = "OK";
                break;
            }
            const subcontent = "";
            const iconType = "";
            const showButton = true;
            const closetimer = 0;
            showAlert({
              title: message,
              text: subcontent,
              icon: iconType,
              showConfirmButton: showButton,
              confirmButtonText: buttonText,
              timer: closetimer,
            });
            
          }
        }
      }
      if (userCoins.betReward != undefined && userCoins.betReward != null) {
        const uiBetReward = uiElements.others["betreward"];
        if (uiBetReward) uiBetReward.innerHTML = userCoins.betReward;
      }
      if (
        userCoins.specialCoins != undefined &&
        userCoins.specialCoins != null
      ) {
        const uiSpecialScore = uiElements.others["specialscore"];
        if (uiSpecialScore)
          uiSpecialScore.innerHTML = intToString(userCoins.specialCoins);
      }
      if (
        userCoins.specialCoinsA != undefined &&
        userCoins.specialCoinsA != null
      ) {
        const uiSpecialScoreA = uiElements.others["specialscore-a"];
        if (uiSpecialScoreA)
          uiSpecialScoreA.innerHTML = intToString(userCoins.specialCoinsA);
      }
    }
  }

  function updateMsg(msg) {
    if (msg != null) {
      const language = AppCtrl.getLanguage();
      if (msg.indexOf("開分共:") != -1) {
        if (language == LANGUAGE_TYPE.en_US) {
          let str = [];
          str = msg.split("次");
          str[0] = str[0] + "times";
          str[1] = str[1] + "times";
          str[2] = str[2] + "times";
          msg = str[0] + str[1] + str[2];
          msg = msg.replace("開分共", "Total KeyIN");
          msg = msg.replace("成功", "Success");
          msg = msg.replace("失敗", "Failed");
        }
        const message = msg;
        const subcontent = "";
        const iconType = "";
        const showButton = false;
        const buttonText = "";
        const closetimer = 2000;
        const ShowKeyInCnt = AppCtrl.showKeyInCnt();
        if (ShowKeyInCnt)
          showAlert({
            title: message,
            text: subcontent,
            icon: iconType,
            showConfirmButton: showButton,
            confirmButtonText: buttonText,
            timer: closetimer,
          });

        enableCreditUIs(true);
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            msg = "開分完成";
            break;
          case LANGUAGE_TYPE.en_US:
          default:
            msg = "KeyIN Finish";
            break;
        }
      }

      if (msg.indexOf("即將開分") != -1) {
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            break;
          case LANGUAGE_TYPE.en_US:
            msg = msg.replace("即將開分", "KeyIn Now");
            break;
          default:
            break;
        }
      }

      if (msg.indexOf("正在開分") != -1) {
        enableCreditUIs(false);
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            break;
          case LANGUAGE_TYPE.en_US:
            msg = msg.replace("正在開分", "KeyIn CNT");
            break;
          default:
            break;
        }
      }

      if (msg.indexOf("即將洗分") != -1) {
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            break;
          case LANGUAGE_TYPE.en_US:
            msg = msg.replace("即將洗分", "KeyOut Now");
            break;
          default:
            break;
        }
      }

      if (msg.indexOf("洗分完成") != -1) {
        enableCreditUIs(true);
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            break;
          case LANGUAGE_TYPE.en_US:
            msg = msg.replace("洗分完成", "KeyOut Finish");
            break;
          default:
            break;
        }
      }

      if (msg.indexOf("洗分") != -1 && bFirstTimeInMachine === false) {
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            break;
          case LANGUAGE_TYPE.en_US:
            msg = msg.replace("洗分", "KeyOut");
          default:
            break;
        }

        bFirstTimeInMachine = true;
        setTimeout(function () {
          AppCtrl.getUserScores();
        }, 1000);
      }
    }

    const uiScoreMsg = uiElements.others["scoremsg"];
    if (uiScoreMsg && uiScoreMsg.innerHTML != msg) {
      uiScoreMsg.innerHTML = msg;
      //
      if (mScoreMsgTimeout) clearTimeout(mScoreMsgTimeout);
      mScoreMsgTimeout = setTimeout(function () {
        mScoreMsgTimeout = null;
        uiScoreMsg.innerHTML = "";
        AppCtrl.setScoreMsg("");
      }, 5000);
    }
  }

  function updateGameplay(obj) {
    if (obj.hasOwnProperty("MachineRun")) {
      const bMachineRun = Boolean(obj["MachineRun"]);
      if (bMachineRun) {
        if (mSpinAnimation) mSpinAnimation.style.display = "";
      } else {
        if (mSpinAnimation) mSpinAnimation.style.display = "none";
      }
    }
    if (obj.hasOwnProperty("BetError")) {
      const betError = obj["BetError"].toString();
      let msg = betError;
      if (msg.search("機台還在運作中") != -1) {
        msg = `<img class="fit-picture" src="img/ChooseMachine/RunHint.jpg?${Math.random()}" width="85%" height="85%"></img>`;
      }

      // AppCtrl.alert(betError);
      showAlert({ title: msg });
    }
    if (obj.hasOwnProperty("KickoutIn")) {
      if (obj.hasOwnProperty("message")) {
        const msg = obj["message"];
        // AppCtrl.alert(msg);
        showAlert({ title: msg });
      } else {
        const objKickoutIn = obj["KickoutIn"];
        const timeout = parseInt(objKickoutIn["Timeout"]);
        const reason = parseInt(objKickoutIn["Reason"]);
      }
    }
    if (obj.hasOwnProperty("ScoringCmd")) {
      const scoringCmd = parseInt(obj["ScoringCmd"]);
      switch (scoringCmd) {
        case ScoringCmd.BeginInScore:
          break;
        case ScoringCmd.BeginOutScore:
          break;
        case ScoringCmd.QueryInScore:
          break;
        case ScoringCmd.QueryOutScore:
          break;
        case ScoringCmd.InScoreDone:
          {
            if (mCreditInDisabledTimeout) {
              clearTimeout(mCreditInDisabledTimeout);
              mCreditInDisabledTimeout = null;
            }
            mbCreditInDisabled = false;
            setGameBtnStatus("開分", defGameBtnStatusUP);
            setGameBtnStatus("洗分", defGameBtnStatusUP);

            enableCreditUIs(true);
          }
          break;
        case ScoringCmd.OutScoreDone:
          {
            if (mCreditOutDisabledTimeout) {
              clearTimeout(mCreditOutDisabledTimeout);
              mCreditOutDisabledTimeout = null;
            }
            mbCreditOutDisabled = false;
            setGameBtnStatus("開分", defGameBtnStatusUP);
            setGameBtnStatus("洗分", defGameBtnStatusUP);

            enableCreditUIs(true);
          }
          break;
      }
    }
    if (obj.hasOwnProperty("SystemBlocked")) {
      const bSystemBlocked = obj["SystemBlocked"];
      if (bSystemBlocked) {
        // disable all game btns
        const bMobileDevice = Utils.detectmob();
        for (let key in mGameBtns) {
          const gameBtn = mGameBtns[key];
          //
          if (bMobileDevice) {
            gameBtn.btn.removeEventListener("touchstart", onGameBtnDown);
            gameBtn.btn.removeEventListener("touchend", onGameBtnUp);
          } else {
            gameBtn.btn.removeEventListener("mousedown", onGameBtnDown);
            gameBtn.btn.removeEventListener("mouseup", onGameBtnUp);
            if(Config?.logingFromMachine === true)
            {
              gameBtn.btn.removeEventListener("touchstart", onGameBtnDown);
              gameBtn.btn.removeEventListener("touchend", onGameBtnUp);
            }
            
          }
        }
        // hide video screen
        for (let i = 0; i < videoIds.length; i++) {
          const uiVideoFrame = document.getElementById(videoIds[i].id);
          if (uiVideoFrame) uiVideoFrame.style.display = "none";
        }
      }
    }
  }

  function updateBroadcasts(obj) {
    /*
        mBroadcastsList = [];

        for (let i = 0 ; i < obj.length ; i++) {
            const id = obj[i].id;
            const text = obj[i].content;
            //const marqueeLife = (parseInt(miBroadcastDistance) / obj[i].content.length / 8) + 7;
            const marqueeLife = (obj[i].content.length / 8) + 7;
            mBroadcastsList.push({
                id: id,
                content: text,
                life: marqueeLife
            });
        }
        */
  }

  function setGameBtnStatus(btnId, status) {
    const lockedMachine = AppCtrl.lockedMachine();
    if (lockedMachine) {
      const gameBtn = mGameBtns[btnId];
      let TimeOut = mInScoreNum * 2500;
      const TimeOutClearScore = 5500;

      if (mInScoreNum > 15 && mInScoreNum < 30) TimeOut = TimeOut * 0.8;
      else if (mInScoreNum >= 30 && mInScoreNum < 50) TimeOut = TimeOut * 0.7;
      else if (mInScoreNum > 50) TimeOut = TimeOut * 0.5;

      if (
        mbCreditInDisabled === false &&
        (btnId === "開分" ||
          btnId === "in" ||
          btnId === "creditin" ||
          btnId === "keyin") &&
        status === defGameBtnStatusDOWN
      ) {
        mbCreditInDisabled = true;
        if (mCreditInThisTime > mCredit) TimeOut = 3500;

        enableCreditUIs(false);
        if (mCreditInDisabledTimeout) clearTimeout(mCreditInDisabledTimeout);
        mCreditInDisabledTimeout = setTimeout(function () {
          mbCreditInDisabled = false;
          enableCreditUIs(true);
          setGameBtnStatus("開分", defGameBtnStatusUP);
        }, TimeOut);
      } else if (
        mbCreditInDisabled === true &&
        btnId === "開分" &&
        status === defGameBtnStatusDOWN
      ) {
        return;
      } else if (
        mbCreditOutDisabled === false &&
        (btnId === "洗分" ||
          btnId === "out" ||
          btnId === "creditout" ||
          btnId === "keyout") &&
        status === defGameBtnStatusDOWN
      ) {
        mbCreditOutDisabled = true;

        enableCreditUIs(false);
        if (mCreditOutDisabledTimeout) clearTimeout(mCreditOutDisabledTimeout);
        mCreditOutDisabledTimeout = setTimeout(function () {
          mbCreditOutDisabled = false;
          enableCreditUIs(true);
          setGameBtnStatus("洗分", defGameBtnStatusUP);
        }, TimeOutClearScore);
      } else if (
        mbCreditOutDisabled === true &&
        btnId === "洗分" &&
        status === defGameBtnStatusDOWN
      ) {
        return;
      }
      // if btn sytatus is same, skip it.
      if (gameBtn && gameBtn.btnStatus !== status) {
        const middleServer = AppCtrl.middleServer();
        const machineInfo = AppCtrl.machineInfo();
        const folderName = machineInfo.gameUI["foldername"];
        gameBtn.btnStatus = status;
        // send request tp lobby manager
        const obj = new Object();
        switch (status) {
          case defGameBtnStatusUP:
            obj["Action"] = ActionID.GameBtnUp;
            obj["ConnectionId"] = middleServer.connectionId();
            gameBtn.btn.src = `./uilayout/${folderName}/${
              gameBtn.Img
            }?${Math.random()}`;
            break;
          case defGameBtnStatusDOWN:
          case defGameBtnStatusDOWN_HOLD:
            obj["Action"] = ActionID.GameBtnDown;
            obj["ConnectionId"] = middleServer.connectionId();
            gameBtn.btn.src = `./uilayout/${folderName}/${
              gameBtn.ImgDown
            }?${Math.random()}`;
            break;
        }

        obj["DeviceId"] = lockedMachine.deviceId;
        obj["MachineId"] = lockedMachine.machineId;
        obj["BtnId"] = gameBtn.Index;
        obj["BtnText"] = gameBtn.btn.id;
        if (gameBtn.btn.id == "開分" || gameBtn.btn.id == "洗分") {
          obj["InScoreNum"] = mInScoreNum;
        }
        AppCtrl.sendRequestAction(obj, RemoteServer.WinLobbyManager);
      }
    }
  }

  function onGameBtnDown(e) {
    if(mBoosting){
      showAlert({ title: `客服代打中,按鍵暫時失效,有問題請詢問客服!!!` });
      return;
    }
      
    let btnId = null;
    let gameBtn;
    if (e.type == "keydown") {
      const key = e.key;

      for (let id in mGameBtns) {
        gameBtn = mGameBtns[id];
        if (key == gameBtn.Keyboard) {
          btnId = id;
          break;
        }
      }
      if (btnId === null || !gameBtn) return;

      console.log(`onGameBtnDown-Keyboard key=${e}.key},code=${e.code}`);
    } else {
      btnId = e.target.id;
      gameBtn = mGameBtns[btnId];
      if (!gameBtn) return;
      console.log("onGameBtnDown");
    }

    // game btn down
    switch (gameBtn.btnHoldType) {
      case uiBtnHoldType.LongPress: //長壓
        if (gameBtn.btnStatus !== defGameBtnStatusDOWN_HOLD)
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
        else setGameBtnStatus(btnId, defGameBtnStatusUP);
        break;
      case uiBtnHoldType.Usual: //一般
        setGameBtnStatus(btnId, defGameBtnStatusDOWN);
        break;
      case uiBtnHoldType.Pinpon: //脈衝
        let intervalPinpon =
          gameBtn.pinponTimerInterval != null &&
          gameBtn.pinponTimerInterval != 0
            ? gameBtn.pinponTimerInterval
            : 500;
        if (!gameBtn.pinponTimer) {
          gameBtn.pinponTimer = setInterval(function () {
            if (gameBtn.btnStatus === defGameBtnStatusDOWN)
              setGameBtnStatus(btnId, defGameBtnStatusUP);
            else setGameBtnStatus(btnId, defGameBtnStatusDOWN);
          }, intervalPinpon);
        } else {
          clearInterval(gameBtn.pinponTimer);
          gameBtn.pinponTimer = null;
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.LongPress_In1Sec: //一秒後長壓
        if (gameBtn.btnStatus !== defGameBtnStatusDOWN_HOLD) {
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
          // set timeoutLongPressed to check hold action
          if (gameBtn.timeoutLongPressed)
            clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = setTimeout(function () {
            gameBtn.timeoutLongPressed = null;
          }, 1000);
        } else {
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.Pinpon_In1Sec: //一秒後脈衝
        let intervalPinpon_In1Sec =
          gameBtn.pinponTimerInterval != null &&
          gameBtn.pinponTimerInterval != 0
            ? gameBtn.pinponTimerInterval
            : 500;
        if (!gameBtn.pinponTimer) {
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
          // set timeoutLongPressed to check hold action
          if (gameBtn.timeoutLongPressed)
            clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = setTimeout(function () {
            gameBtn.timeoutLongPressed = null;
            // trigger pinponTimer
            gameBtn.pinponTimer = setInterval(function () {
              if (gameBtn.btnStatus === defGameBtnStatusDOWN)
                setGameBtnStatus(btnId, defGameBtnStatusUP);
              else setGameBtnStatus(btnId, defGameBtnStatusDOWN);
            }, intervalPinpon_In1Sec);
          }, 1000);
        } else {
          clearInterval(gameBtn.pinponTimer);
          gameBtn.pinponTimer = null;
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      default:
        console.log(
          `onGameBtnDown() unsupported btnHoldType: ${gameBtn.btnHoldType}`
        );
        break;
    }
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
    // proceed btn down event
    switch (btnId) {
      case "history":
      case "履歷":
        setHistoryTriggered(true);
        break;
      default:
        break;
    }
  }

  function onGameBtnUp(e) {
    let btnId = null;
    let gameBtn;
    if (e.type == "keyup") {
      const key = e.key;

      for (let id in mGameBtns) {
        gameBtn = mGameBtns[id];
        if (key == gameBtn.Keyboard) {
          btnId = id;
          break;
        }
      }
      if (btnId === null || !gameBtn) return;

      console.log(`onGameBtnUp-Keyboard key=${e}.key},code=${e.code}`);
    } else {
      btnId = e.target.id;
      gameBtn = mGameBtns[btnId];
      if (!gameBtn) return;
      console.log("onGameBtnUp");
    }

    // game btn up
    switch (gameBtn.btnHoldType) {
      case uiBtnHoldType.LongPress: //長壓
        // do nothing
        break;
      case uiBtnHoldType.Usual: //一般
        setGameBtnStatus(btnId, defGameBtnStatusUP);
        break;
      case uiBtnHoldType.Pinpon: //脈衝
        // do nothing
        break;
      case uiBtnHoldType.LongPress_In1Sec: //一秒後長壓
        if (gameBtn.timeoutLongPressed) {
          clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = null;
          // cancel long press
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.Pinpon_In1Sec: //一秒後脈衝
        if (gameBtn.timeoutLongPressed) {
          clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = null;
          // cancel pinponTimer
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      default:
        console.log(
          `onGameBtnUp() unsupported btnHoldType: ${gameBtn.btnHoldType}`
        );
        break;
    }
    // proceed btn up event
    switch (btnId) {
      case "history":
      case "履歷":
        break;
      default:
        break;
    }
  }

  function onResize() {
    const machineInfo = AppCtrl.machineInfo();
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    buildGameUI(deviceWidth, deviceHeight, machineInfo.gameUI);
  }

  function checkReconnect() {
    // update mLastReloadTime to avoid trigger new doReload
    //mLastReloadTime = new Date();
    //
    if (mCheckCheckReconnect) clearTimeout(mCheckCheckReconnect);
    mCheckCheckReconnect = setTimeout(function () {
      mCheckCheckReconnect = null;

      const middleServer = AppCtrl.middleServer();
      if (middleServer.isConnected()) {
        const language = AppCtrl.getLanguage();
        // do join again
        const lobbyName = AppCtrl.lobbyName();
        if (lobbyName) {
          AppCtrl.joinLobby(lobbyName, true);
        }

        const uiExit = document.getElementById("exit");
        if (uiExit) {
          uiExit.style.opacity = 1;
          uiExit.disabled = false;
        }

        let msg = "";
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            msg = "連線成功";
            break;
          case LANGUAGE_TYPE.en_US:
          default:
            msg = "Connect Success!";
            break;
        }
        AppCtrl.setScoreMsg(msg);
        updateMsg(msg);
        // reload done, delay then reset mLastReloadTime
        setTimeout(function () {
          //mLastReloadTime = new Date(0);
          enableCreditUIs(true);
        }, 500);
      } else {
        checkReconnect();
      }
    }, 200);
  }

  function doRestart() {
    /// proceed reconnect
    AppCtrl.reconnectToServer(function () {
      for (let i = 0; i < mVideoUINum; i++) {
        stopVideo(i);
      }
      // restart videos
      // for (let i = 0; i < mVideoUINum; i++) {
      //   startVideo(i, videoInfo[i].source, videoInfo[i].angle);
      // }
      AppCtrl.setMachineTokenCB(() => {
        for (let i = 0; i < mVideoUINum; i++) {
          startVideo(i, videoInfo[i].source, videoInfo[i].angle);
        }
      });
      checkReconnect();
      enableCreditUIs(true);
      Utils.enterFullScreen();
    });
  }

  function doReconnectTimer() {
    AppCtrl.reconnectToServer(function () {
      checkReconnect();
    });
  }
  function openStore() {
    const storeUrl = Config?.urlBuyScores?.trim();
    if (storeUrl && storeUrl !== "") {
        window.open(`${storeUrl}?account=${AppCtrl.getAccount()}`);
      } else {
        alert(`There is no store/無商店功能.`);
      }
  }
  function doReload() {
    //doReload
    const curTime = new Date();
    const ts = curTime - mLastReloadTime;
    if (ts > 8000) {
      mLastReloadTime = curTime;
      enableCreditUIs(false);

      for (let i = 0; i < mVideoUINum; i++) {
        stopVideo(i);
      }
      const uiExit = document.getElementById("exit");
      if (uiExit) {
        uiExit.style.opacity = 0.3;
        uiExit.disabled = true;
      }
      // proceed reconnect
      AppCtrl.reconnectToServer(function () {
        if (isFullscreenInBonusView) {
          // for (let i = 0; i < mVideoUINum; i++) {
          //   startVideo(i, videoInfo[i].source, videoInfo[i].angle);
          //   const uiView = document.getElementById(videoIds[i].id);
          //   if (uiView) uiView.hidden = i != 2 ? false : true;
          // }
          AppCtrl.setMachineTokenCB(() => {
            startVideo(i, videoInfo[i].source, videoInfo[i].angle);
            const uiView = document.getElementById(videoIds[i].id);
            if (uiView) uiView.hidden = i != 2 ? false : true;
          });
          mMSDisplayIndex = 0;
        } else {
          if (isTrunview) {
            // for (let i = 0; i < mVideoUINum; i++) {
            //   startVideo(i, videoInfo[i].source, videoInfo[i].angle);
            //   const uiTurnViewScreen = document.getElementById(videoIds[i].id);
            //   if (uiTurnViewScreen)
            //     uiTurnViewScreen.hidden = mVideoUIIndex === i ? false : true;
            // }
            AppCtrl.setMachineTokenCB(() => {
              startVideo(i, videoInfo[i].source, videoInfo[i].angle);
              const uiTurnViewScreen = document.getElementById(videoIds[i].id);
              if (uiTurnViewScreen)
                uiTurnViewScreen.hidden = mVideoUIIndex === i ? false : true;
            });
          } else {
            const uiIndex = mVideoUIIndex;
            // switch to original view layout
            for (let i = uiIndex; i < mVideoUINum; i++) {
              switchView();
            }
            // restart videos
            AppCtrl.setMachineTokenCB(() => {
              for (let i = 0; i < mVideoUINum; i++) {
                startVideo(i, videoInfo[i].source, videoInfo[i].angle);
                const uiViewScreen = document.getElementById(videoIds[i].id);
                if (uiViewScreen)
                  uiViewScreen.hidden = mVideoUIIndex === i ? false : true;
              }
            });
            // for (let i = 0; i < mVideoUINum; i++) {
            //   startVideo(i, videoInfo[i].source, videoInfo[i].angle);
            //   const uiViewScreen = document.getElementById(videoIds[i].id);
            //   if (uiViewScreen)
            //     uiViewScreen.hidden = mVideoUIIndex === i ? false : true;
            // }
            // back to users' lastest view layout
            for (let i = 0; i < uiIndex; i++) {
              switchView();
            }
          }
        }

        checkReconnect();
      });
    }
  }

  async function exitConfirmed() {
    const language = AppCtrl.getLanguage();
    const lockedMachine = AppCtrl.lockedMachine();
    const userInfo = AppCtrl.userInfo();
    const winAward = AppCtrl.winAward();
    let bUnlockGuoZhao = false;
    let unLockGuoCondition = 0;

    if (lockedMachine.canGuoZhao && userInfo.guoZhaoInfo()) {
      const guoZhaoInfo = userInfo.guoZhaoInfo();
      const totalGuoZhaoScores =
        userInfo.InGuoZhaoCoins - userInfo.OutGuoZhaoCoins;

      if (lockedMachine.guoZhaoUnlockWhenWinAward) {
        if (winAward) unLockGuoCondition = 1;
        else if (totalGuoZhaoScores < mSingleInScore) unLockGuoCondition = 2;
      } else {
        if (totalGuoZhaoScores >= lockedMachine.unlockGuoZhaoScore)
          unLockGuoCondition = 1;
        else if (totalGuoZhaoScores < mSingleInScore) unLockGuoCondition = 2;
      }

      console.log(
        `${userInfo.Account} has ${totalGuoZhaoScores} guoZhao scores`
      );
      // check if user's scores can unlock GuoZhao, popup message
      if (
        lockedMachine.deviceId == guoZhaoInfo.DeviceId &&
        lockedMachine.machineId == guoZhaoInfo.MachineId &&
        unLockGuoCondition >= 1
      ) {
        console.log(`exitConfirmed totalGuoZhaoScores:${totalGuoZhaoScores}`);
        const myPromise = new Promise((resolve, reject) => {
          try {
            let title = "";
            let message = "";
            let okText = "";
            let cancelText = "";
            switch (language) {
              case LANGUAGE_TYPE.zh_TW:
                title = "";
                if (unLockGuoCondition == 1)
                  message = `過招條件達成，要停止過招嗎?(解招須稍等3分鐘)`;
                else
                  message = `過招錢包分數低於低標，要解除過招嗎?(解招須稍等3分鐘)`;
                okText = "是";
                cancelText = "否";
                break;
              case LANGUAGE_TYPE.en_US:
              default:
                title = "";
                if (unLockGuoCondition == 1)
                  message = `you had won the GuoZhao, stop it?`;
                else message = `you had lost the GuoZhao, stop it?`;
                okText = "Yes";
                cancelText = "No";
                break;
            }
            // do confirm
            setTimeout(() => {
              showAlert({
                title,
                text: message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: okText,
                cancelButtonText: cancelText,
                confirmCb: function () {
                  resolve(true);
                },
                cancelCb: function () {
                  resolve(false);
                },
              });
            }, 500);
            
          } catch (err) {
            resolve(false);
          }
        });
        bUnlockGuoZhao = await myPromise;
      }
    }

    AppCtrl.unlockMachine(bUnlockGuoZhao);
    isFullScreen = false;

    // 機器人模式：先回到選機台，再依機率跳 LoginPage
    // 測試方便先設成 1（100% 會執行）；正式可用 AppCtrl.setRobotBackToLoginRate(0~1) 動態調整
    //AppCtrl.setRobotBackToLoginRate(1);
    if (AppCtrl.isRobotMode() && AppCtrl.shouldRobotBackToLogin()) {
      // 先回到選機台（保留連線，讓大廳能正常顯示）
      AppCtrl.switchPage(EPage.lobby);

    //   // 再延遲關閉連線並跳 LoginPage
    //   const backToLoginDelayMs = 1500; // 需更久可自行調整
    //   setTimeout(() => {
    //     try { 
    //       //AppCtrl.middleServer().stop(); 
          
    //       //AppCtrl.switchPage(EPage.main);
    //       AppCtrl.leaveLobby();
    //       setFunc(EFunction.login);
    //       //AppCtrl.middleServer().stop(); 
    //       //AppCtrl.switchPage(EPage.main);
    //     } catch (e) {
    //        /* ignore */ 
    //        console.log(`backToLogin error: ${e}`);
    //       }
        
    //   }, backToLoginDelayMs);

      // 再延遲關閉連線並跳 LoginPage
      const backToLoginDelayMs = 1500; // 需更久可自行調整
      setTimeout(() => {
        try {
          // 先離開大廳
          try { AppCtrl.leaveLobby(); } catch (e) {console.log(`AppCtrl.leaveLobby() error: ${e}`);}

          // 停掉中介連線，避免自動導回已登入狀態
          try {
            const ms = AppCtrl.middleServer && AppCtrl.middleServer();
            if (ms && typeof ms.stop === "function") ms.stop();
          } catch (e) {console.log(`ms.stop() error: ${e}`);}

          // 切到主頁（LoginPage）
          const userAccount = userInfo ? userInfo.Account : "";
          const userPassword = AppCtrl.cachePassword() ?  AppCtrl.cachePassword() : "12345";
          AppCtrl.setCacheAccount(userAccount);
          AppCtrl.setCachePassword(userPassword);
          AppCtrl.switchPage(EPage.main);
          setFunc(EFunction.login);
        } catch (e) {
          console.log(`backToLogin error: ${e}`);
        }
      }, backToLoginDelayMs);
       return; // 不再走原本回大廳提示流程
    }
    

    // show popup
    let msg = "";
    switch (language) {
      case LANGUAGE_TYPE.zh_TW:
        msg = `正在回到大廳\n請稍候。`;
        break;
      case LANGUAGE_TYPE.en_US:
      default:
        msg = `Back to lobby\nplease wait.`;
        break;
    }
    showAlert({ title: msg, showConfirmButton: false, timer: 4000 });
    // AppCtrl.popup(msg);
    // delay for LobbyManager finishes UnlockMachine
    setTimeout(function () {
      AppCtrl.switchPage(EPage.lobby);
      // navigate('/lobbyPage');
    }, 1500);
  }

  function exitCanceled() {
    // Swal.fire({
    // 	title: '請繼續進行遊戲',
    // 	text: '',
    // 	icon: 'success',
    // 	confirmButtonText: '關閉'
    //   });
  }

  function exit(e) {
    const language = AppCtrl.getLanguage();

    let message = "";
    let text = "";
    let conformText = "";
    let cancelText = "";
    if(mBoosting)  {
      message = `管理員代玩中，暫時無法退出，有問題請聯繫客服人員`;
      conformText = "OK";
    }
    else{
      switch (language) {
        case LANGUAGE_TYPE.zh_TW:
          message =
            '<div style={{top:"40px", color:"#ffffff"}}>' +
            "<h3>請注意!!!</h3>" +
            "<h5> ⚠️本遊戲為實體機台⚠️</h5>" +
            "<h5>退出機台時，請務必將機台分數退分至錢包中，若無退分系統無法補償玩家</h5>" +
            "<h5>⭐️請確認無分數再離開機台⭐️</h5>" +
            "</div>";
          text = "釋放座位給予其他玩家遊玩嗎??";
          conformText = "確定離開";
          cancelText = "繼續遊戲";
          break;
        case LANGUAGE_TYPE.en_US:
        default:
          message =
            '<div style={{top:"40px", color:"#ffffff"}}>' +
            "<h3>Notice!!!</h3>" +
            "<h5>It is real slot machine.</h5>" +
            "<h5>Please keyout your score before you exit.</h5>" +
            "</div>";
          text = "Exit??";
          conformText = "OK";
          cancelText = "Cancel";
          break;
      }
    }
    
    if(mBoosting) {
      showAlert({
        title: message,
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: conformText,
      });
    }
    else{
      //do confirm
      showAlert({
        title: message,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: conformText,
        cancelButtonText: cancelText,
        confirmCb: function () {
          exitConfirmed();
        },
        cancelCb: function () {
          exitCanceled();
        },
      });
    }
    
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
   
  }

  function setBGImg(imgUrl, boundary, folderName) {
    const element = document.getElementById(bgImgId);
    if (element) {
      element.src = `./uilayout/${folderName}/${imgUrl}?${Math.random()}`;
      element.style.position = "absolute";
      element.style.left = "0px";
      element.style.top = "0px";
      element.style.width = `${boundary.w}px`;
      element.style.height = `${boundary.h}px`;
    }
  }

  function setMachine(machine, boundary, folderName) {
    if (machine.hasOwnProperty("bgImg")) {
      const bgImg = machine["bgImg"];
      if (bgImg) setBGImg(bgImg, boundary, folderName);
    }
  }

  function createSelect(folderName, config) {
    const id = config["id"];
    const items = config["items"].split(",");
    const element = document.createElement("select");
    element.id = id;
    for (let i = 0; i < items.length; i++) {
      const option = document.createElement("option");
      option.value = items[i];
      option.innerHTML = `開分${items[i]}次`;
      element.appendChild(option);
    }
    element.addEventListener("change", function (e) {
      onInScoreTimesChanged(e.target);
    });

    return element;
  }

  function createPoint(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createBetTarget(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "center";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createMachineScore(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createScore(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createStore(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", openStore);
    return element;
  }
   

  function createSpecialScore(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#ffd700";
    return element;
  }
  function createSpecialScoreA(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#ffd700";
    return element;
  }

  function createnormalScore(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#ffd700";
    return element;
  }

  function createScoreMsg(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createReload(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", doReload);
    return element;
  }

  function createExit(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", exit);
    return element;
  }

  function createBroadcastpanel(boundary, folderName, config) {
    const id = config["id"];
    const element = document.createElement("marquee");
    let direction = config["text"];
    const uiSize = config["size"].split(","); // : [30, 30];
    const life = 5000;
    if (direction == "") direction = "left";
    if (direction === "left" || direction === "right") {
      element.style.fontSize = `${(uiSize[1] / 10) * 1.5}px`; //"28px"
      miBroadcastDistance = `${uiSize[0] * boundary.scaleX}`;
    } else {
      element.style.fontSize = `${(uiSize[0] / 10) * 1.5}px`; //"28px"
      miBroadcastDistance = `${uiSize[1] * boundary.scaleY}`;
    }

    element.style.fontWeight = "bold";
    //element.style.width = `${uiSize[0] * boundary.scaleX}px`;
    //element.style.height = `${uiSize[1] * boundary.scaleY}px`;
    element.id = id;
    element.innerText = mBroadcast;
    element.direction = direction;
    if (hdlUpdateBroadcast) clearTimeout(hdlUpdateBroadcast);
    hdlUpdateBroadcast = setTimeout(() => {
      showNextBroadcastMsg();
    }, life);
    iMsgIndex = 0;
    return element;
  }

  function createFullscreen(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", fullscreen);
    return element;
  }

  function createPopscreen(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";

    element.addEventListener("click", popScreen);
    return element;
  }

  function createMainView(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", mainView);
    return element;
  }

  function createRestart(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", doRestart);
    return element;
  }

  function createView(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", switchView);
    return element;
  }

  function createTurnView(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", TurnView);
    return element;
  }

  function createMachineTitle(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("div");
    element.id = id;
    const show = config["text"];
    const machine = AppCtrl.lockedMachine();

    if (show != "false") {
      const bgImage = document.createElement("img");
      bgImage.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
      bgImage.style.position = "absolute";
      bgImage.style.left = "0px";
      bgImage.style.top = "0px";
      bgImage.style.width = "100%";
      bgImage.style.height = "100%";
      element.appendChild(bgImage);

      const text = document.createElement("div");
      text.style.position = "absolute";
      text.style.left = "0px";
      text.style.top = "0px";
      text.style.width = "100%";
      text.style.height = "100%";
      text.style.textAlign = "center";
      text.style.fontSize = "20px";

      if (machine.isTrial) {
        text.innerHTML = `${machine.MachineName}(試)`;
      } else {
        text.innerHTML = AppCtrl.isUserOnGuoZhao()
          ? `${machine.MachineName}(招)`
          : `${machine.MachineName}`;
      }
      element.appendChild(text);
    } else {
      element.innerHTML = machine.MachineName;
      element.style.textAlign = "center";
      element.style.color = "#FFFFFF";
    }

    return element;
  }

  function createAccountTitle(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("div");
    element.id = id;
    const show = config["text"];
    const uiAccount = AppCtrl.getAccount();

    if (show != "false") {
      const bgImage = document.createElement("img");
      bgImage.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
      bgImage.style.position = "absolute";
      bgImage.style.left = "0px";
      bgImage.style.top = "0px";
      bgImage.style.width = "100%";
      bgImage.style.height = "100%";
      element.appendChild(bgImage);

      const text = document.createElement("div");
      text.style.position = "absolute";
      text.style.left = "0px";
      text.style.top = "0px";
      text.style.width = "100%";
      text.style.height = "100%";
      text.style.textAlign = "center";
      text.style.fontSize = "20px";

      text.innerHTML = uiAccount;
      element.appendChild(text);
    } else {
      element.innerHTML = uiAccount;
      element.style.textAlign = "center";
      element.style.color = "#FFFFFF";
    }

    return element;
  }
  function createMegaStatue(folderName, config) {
    const id = config["id"];
    mMegeStateTitle = config["text"];
    const text = document.createElement("div");
    text.id = id;
    text.innerHTML = `${mMegeStateTitle} : ${winAToBonus} / ${winABase}`;
    text.style.position = "absolute";
    text.style.left = "0px";
    text.style.top = "0px";
    text.style.width = "100%";
    text.style.height = "100%";
    //text.style.textAlign = "center";
    text.style.fontSize = "20px";
    text.style.textAlign = "left";
    const color = config["Color"];
    text.style.color = color;
    return text;
  }
  function createMiniStatue(folderName, config) {
    const id = config["id"];
    mMiniStateTitle = config["text"];
    const text = document.createElement("div");
    text.id = id;
    text.innerHTML = `${mMiniStateTitle} : ${winBToBonus} / ${winBBase}`;
    text.style.position = "absolute";
    text.style.left = "0px";
    text.style.top = "0px";
    text.style.width = "100%";
    text.style.height = "100%";
    //text.style.textAlign = "center";
    text.style.fontSize = "20px";
    text.style.textAlign = "left";
    const color = config["Color"];
    text.style.color = color;
    return text;
  }
  function createImg(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const text = config["text"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    return element;
  }
  function createSpecialCoin(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    return element;
  }
  function createSpecialCoinA(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    return element;
  }
  function createNormalCoin(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = !machine.isTrial
      ? `./uilayout/${folderName}/${img}?${Math.random()}`
      : `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    return element;
  }
  function createCoin(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgGuoZhao = "GuoZhao.gif";
    const imgTrialGuoZhao = "TrialGuoZhao.gif";
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;

    if (!machine.isTrial) {
      element.src = AppCtrl.isUserOnGuoZhao()
        ? `./uilayout/${folderName}/${imgGuoZhao}?${Math.random()}`
        : `./uilayout/${folderName}/${img}?${Math.random()}`;
      mCoinImg = `./uilayout/${folderName}/${img}?${Math.random()}`;
    } else {
      element.src = AppCtrl.isUserOnGuoZhao()
        ? `./uilayout/${folderName}/${imgTrialGuoZhao}?${Math.random()}`
        : `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
      mCoinImg = `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    }

    return element;
  }
  function createSpin(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = !machine.Trial
      ? `./uilayout/${folderName}/${img}?${Math.random()}`
      : `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    return element;
  }
  function createHere(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = !machine.Trial
      ? `./uilayout/${folderName}/${img}?${Math.random()}`
      : `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    return element;
  }

  function createImgBtn(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const Display = config["text"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    if (Display === "none") element.style.display = Display;
    return element;
  }

  function createBonusIframe(config) {
    const bonusType = config["bonusType"];

    let element = document.createElement("iframe");
    if((Config?.urlBonus?.trim() !== ""))
    {
      element.src = `${Config.urlBonus}/bonusClient/bonusInGame/${bonusType}`;
      element.style.borderWidth = "0px";
      element.style.overflowY = "auto";
      element.style.position = "absolute";
    }
    return element;
  }

  function createBonusLink(config) {
    if (!shoBonusBtn) return null;

    let element = document.createElement("button");
    element.id = config.id;
    element.className = styles.bonusLink;
    element.textContent = config.text;
    element.addEventListener("click", handleBonusBtnClick);
    element.addEventListener("mousedown", handleBonusBtnClick);
    element.addEventListener("touchstart", handleBonusBtnClick);
    return element;
  }

  function setGameOthers(gameothers, boundary, folderName, uiMainArea) {
    // do sort to make sure the order are matched to manager's prefered order
    gameothers.sort(function (a, b) {
      if (a.index < b.index) return -1;
      else return 1;
    });

    // reset screen number
    mVideoUINum = 0;
    let bPopScreen = false;
    let bScreen = false;
    const showJackpot = Config?.showJackpot ?? false;
    for (let i = 0; i < gameothers.length; i++) {
      bScreen = false;
      const obj = gameothers[i];
      let id = obj.hasOwnProperty("id")
        ? obj["id"].toString().toLowerCase()
        : null;
      let keyboard = obj.hasOwnProperty("Keyboard") ? obj["Keyboard"] : "";
      let img = obj.hasOwnProperty("Img") ? obj["Img"] : "";
      let imgDown = obj.hasOwnProperty("ImgDown") ? obj["ImgDown"] : "";
      let zIndex = obj.hasOwnProperty("zIndex") ? obj["zIndex"] : 0;

      // skip null id obj
      if (!id) continue;
      // sync id
      else obj["id"] = id;

      if (id == "screen" || id == "screen1" || id == "screen2") {
        // increase video number
        mVideoUINum++;
      }

      if (id.includes("bonusiframe")) {
        obj["bonusType"] = id.split("bonusiframe")[1];
      }

      let element = null;
      let eventID = "onOtherBtnDown";
      if (!uiElements.others[id]) {
        // create element
        switch (id) {
          case "megastate":
            element = createMegaStatue(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
            case "ministate":
            element = createMiniStatue(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "selector":
            element = createSelect(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "point":
            element = createPoint(obj);
            uiMainArea.appendChild(element);
            break;
          case "score":
            element = createScore(obj);
            uiMainArea.appendChild(element);
            break;
          case "store":
            element = createStore(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "normalscore":
            if (AppCtrl.isUserOnGuoZhao()) {
              element = createnormalScore(obj);
              uiMainArea.appendChild(element);
            }
            break;
          case "scoremsg":
            element = createScoreMsg(obj);
            uiMainArea.appendChild(element);
            break;
          case "reload":
            element = createReload(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "exit":
            element = createExit(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "exit";
            break;
          case "fullscreen":
            element = createFullscreen(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "fullscreen";
            break;
          case "popscreen":
            bPopScreen = true;
            element = createPopscreen(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "restart":
            element = createRestart(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "turnview":
            element = createTurnView(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            isTrunview = true;
            break;
          case "view":
            element = createView(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "mainview":
            element = createMainView(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "screen":
            element = document.getElementById(videoIds[0].id);
            bScreen = true;
            break;
          case "screen1":
            element = document.getElementById(videoIds[1].id);
            bScreen = true;
            break;
          case "screen2":
            element = document.getElementById(videoIds[2].id);
            bScreen = true;
            break;
          case "panelbetwin":
            element = document.getElementById(id);
            break;
          case "machinetitle":
            element = createMachineTitle(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "account":
            element = createAccountTitle(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "coin":
            element = createCoin(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "specialcoin":
            element = createSpecialCoin(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "specialcoinA":
            element = createSpecialCoinA(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "specialscore":
            element = createSpecialScore(obj);
            uiMainArea.appendChild(element);
            break;
          case "specialscore-a":
            element = createSpecialScoreA(obj);
            uiMainArea.appendChild(element);
            break;
          case "spin":
            element = createSpin(folderName, obj);
            uiMainArea.appendChild(element);
            element.style.display = "none";
            mSpinAnimation = element;
            break;
          case "here":
            element = createHere(folderName, obj);
            uiMainArea.appendChild(element);
            element.style.display = "none";
            mHereAnimation = element;
            break;
          case "tianjing":
            element = createHere(folderName, obj);
            uiMainArea.appendChild(element);
            element.style.display = "none";
            mTianjing = element;
            break;
          case "broadcastpanel":
            element = createBroadcastpanel(boundary, folderName, obj);
            uiMainArea.appendChild(element);
            //element.style.display = 'none';
            break;
          case "normalcoin":
            if (AppCtrl.isUserOnGuoZhao()) {
              element = createNormalCoin(folderName, obj);
              uiMainArea.appendChild(element);
            }
            break;
          case "bonusiframe1":
          case "bonusiframe2":
          case "bonusiframe3":
          case "bonusiframe4":
          case "bonusiframe5":
            if(showJackpot){
              element = createBonusIframe(obj);
              uiMainArea.appendChild(element);
            }
            break;
          case "bonuslink":
            element = createBonusLink(obj);
            uiMainArea.appendChild(element);
            break;
          default:
            element = createImg(folderName, obj);
            uiMainArea.appendChild(element);
            break;
        }
        // keep element
        if (element != null) {
          uiElements.others[id] = element;

          mGameOthers[id] = {
            btnEvent: eventID,
            btn: element,
            Keyboard: keyboard,
            Img: img,
            ImgDown: imgDown,
            btnID: id,
          };
        }
      } else {
        element = uiElements.others[id];
      }

      const pos = obj.hasOwnProperty("pos") ? obj["pos"].split(",") : [0, 0];
      const uiSize = obj.hasOwnProperty("size")
        ? obj["size"].split(",")
        : [0, 0];
      const scale = obj?.scale ? obj.scale : 1;

      if (element) {
        element.style.position = "absolute";
        element.style.left = `${pos[0] * boundary.scaleX}px`;
        element.style.top = `${pos[1] * boundary.scaleY}px`;
        //element.style.width = `${uiSize[0] * boundary.scaleX}px`;
        element.style.height = `${uiSize[1] * boundary.scaleY}px`;
        
        element.style.zIndex = `${zIndex}`;
        //bScreen = false;
        if (bScreen === true) {
          //element.style.scale = ScaleW;
          element.style.width = `${uiSize[0] * boundary.scaleX * ScaleW}px`;
        } else {
          element.style.width = `${uiSize[0] * boundary.scaleX}px`;
        }
        

        if (id.includes("bonusiframe")) {
          // 保持 iframe 原始尺寸
          element.style.width = `${uiSize[0]}px`;
          element.style.height = `${uiSize[1]}px`;
          
          // 計算縮放中心點偏移
          const transformOriginX = 0;
          const transformOriginY = 0;
          element.style.transformOrigin = `${transformOriginX}px ${transformOriginY}px`;

          // 計算縮放比例 - 使用容器寬高比例
          const scaleX = (uiSize[0] * boundary.scaleX) / uiSize[0];
          const scaleY = (uiSize[1] * boundary.scaleY) / uiSize[1];
          const scaleValue = Math.min(scaleX, scaleY);

          // 計算經過縮放後的實際位置
          const scaledLeft = pos[0] * boundary.scaleX;
          const scaledTop = pos[1] * boundary.scaleY;

          // 應用變換
          element.style.transform = `scale(${scaleValue * scale})`;
          element.style.left = `${scaledLeft}px`;
          element.style.top = `${scaledTop}px`;
        }
        
      } else {
        console.log(`null element, id:${id}`);
      }
    }

    // sync value of point
    onInScoreTimesChanged(uiElements.others["selector"]);
    const fontSize = Math.floor(48 * boundary.scaleX);
    const paddingTop = Math.floor(10 * boundary.scaleY);
    // change fontSize of point/score/msg
    if (uiElements.others.hasOwnProperty("point")) {
      const uiPoint = uiElements.others["point"];
      uiPoint.style.fontSize = `${fontSize}px`;
      uiPoint.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("score")) {
      const uiScore = uiElements.others["score"];
      uiScore.style.fontSize = `${fontSize}px`;
      uiScore.style.paddingTop = `${paddingTop}px`;
    }
    if (
      uiElements.others.hasOwnProperty("normalscore") &&
      AppCtrl.isUserOnGuoZhao()
    ) {
      const uiNormalScore = uiElements.others["normalscore"];
      uiNormalScore.style.fontSize = `${fontSize}px`;
      uiNormalScore.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("specialscore")) {
      const uiSpecialScore = uiElements.others["specialscore"];
      uiSpecialScore.style.fontSize = `${fontSize}px`;
      uiSpecialScore.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("specialscore-a")) {
      const uiSpecialScoreA = uiElements.others["specialscore-a"];
      uiSpecialScoreA.style.fontSize = `${fontSize}px`;
      uiSpecialScoreA.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("scoremsg")) {
      const uiScoreMsg = uiElements.others["scoremsg"];
      uiScoreMsg.style.fontSize = `${fontSize}px`;
      uiScoreMsg.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("machinetitle")) {
      const uiMachineTitle = uiElements.others["machinetitle"];
      const titleFontSize = Math.floor(fontSize * 1.2);
      const titlePaddingTop = Math.floor(paddingTop * 1.5);
      for (let i = 0; i < uiMachineTitle.children.length; i++) {
        const child = uiMachineTitle.children[i];
        if (!child.innerText) continue;
        child.style.fontSize = `${titleFontSize}px`;
        child.style.paddingTop = `${titlePaddingTop}px`;
      }
    }

    if (bPopScreen) {
      const uiView = document.getElementById(videoIds[2].id);
      uiView.hidden = true;
      displayElement(true);
    }
    if (isTrunview) {
      const uiView0 = document.getElementById(videoIds[0].id);
      uiView0.hidden = false;
      const uiView1 = document.getElementById(videoIds[1].id);
      uiView1.hidden = true;
      const uiView2 = document.getElementById(videoIds[2].id);
      uiView2.hidden = true;
    }
  }

  function showNextBroadcastMsg() {
    return;
    //
    // const uiBroadcastMsg = document.getElementById('broadcastpanel');
    // if (mBroadcastsList.length > 0) {
    //     uiBroadcastMsg.style.opacity = 1.0;
    //     //uiBroadcastMsg.behavior = scroll;
    //     switch(iColorIndex)
    //     {
    //         case 0:
    //             iColorIndex++;
    //             uiBroadcastMsg.style.textShadow = "0 0 0.2em #F87, 0 0 0.2em #F87";
    //         break;

    //         case 1:
    //             iColorIndex++;
    //             uiBroadcastMsg.style.textShadow = "0 0 0.2em #87F, 0 0 0.2em #87F,0 0 0.2em #87F";
    //         break;

    //         case 2:
    //             iColorIndex = 0;
    //             uiBroadcastMsg.style.textShadow = "0 0 0.2em #8F7, 0 0 0.2em #8F7";

    //         break;

    //         default:
    //             iColorIndex = 0;
    //             uiBroadcastMsg.style.textShadow = "0 0 0.2em #8F7, 0 0 0.2em #8F7";
    //         break;
    //     }

    //     //uiBroadcastMsg.style.fontSize = "28px"
    //     //uiBroadcastMsg.style.fontWeight = "bold";
    //     mBroadcast = mBroadcastsList[iMsgIndex].content;
    //     uiBroadcastMsg.innerText = mBroadcast;
    //     //uiBroadcastMsg.textContent = mBroadcast;
    //     //element.innerText =
    //     iMsgIndex++;
    //     if(iMsgIndex >= mBroadcastsList.length)
    //         iMsgIndex = 0;

    //     // trigger next msg
    //     hdlUpdateBroadcast = setTimeout(() => {
    //         showNextBroadcastMsg();
    //     }, mBroadcastsList[iMsgIndex].life * 1000);
    // }
    // else {
    //     uiBroadcastMsg.style.opacity = 0.3;
    //     iMsgIndex = 0;
    // }
  }

  function setGameBtns(gamebtns, boundary, folderName, uiMainArea) {
    const machineInfo = AppCtrl.machineInfo();
    const btnHoldType = machineInfo.btnHoldType;
    const btnPinponTimers = machineInfo.btnPinponTimers;

    gamebtns.sort(function (a, b) {
      if (a.index < b.index) return -1;
      else return 1;
    });

    gameBtnOrderRef.current = [];

    for (let i = 0; i < gamebtns.length; i++) {
      const obj = gamebtns[i];
      const id = obj.id;
      // 0=正常, 1=保持按下, 2=不按, 3=每0.5秒按一下
      const type = Object.prototype.hasOwnProperty.call(obj, "type")
        ? Number(obj.type)
        : 0;

      gameBtnOrderRef.current.push(id);

      const pos = obj.hasOwnProperty("pos") ? obj["pos"].split(",") : [0, 0];
      const uiSize = obj.hasOwnProperty("size") ? obj["size"].split(",") : [0, 0];

      let element = null;
      if (!uiElements.btns[id]) {
        const text = obj["text"];
        const index = obj["index"];
        const img = obj["Img"];
        const imgDown = obj["ImgDown"];
        const pushpinpos = obj.hasOwnProperty("pushpinpos")
          ? obj["pushpinpos"].split(",")
          : [0, 0];
        const pushpinsize = obj.hasOwnProperty("pushpinsize")
          ? obj["pushpinsize"].split(",")
          : [0, 0];
        const keyboard = obj.hasOwnProperty("Keyboard") ? obj["Keyboard"] : "";

        element = createImgBtn(folderName, obj);
        uiMainArea.appendChild(element);
        uiElements.btns[id] = element;

        mGameBtns[id] = {
          btnStatus: defGameBtnStatusUP,
          btnHoldType: btnHoldType ? btnHoldType[i] : 0,
          timeoutLongPressed: null,
          pinponTimer: null,
          pinponTimerInterval: btnPinponTimers ? btnPinponTimers[i] : 500,
          Text: text,
          Index: index,
          Img: img,
          ImgDown: imgDown,
          PushpinPos: pushpinpos,
          PushpinSize: pushpinsize,
          btn: element,
          Keyboard: keyboard,
          btnID: id,
          RobotType: type, // 新增：記錄機器人按鍵型態
        };
      } else {
        element = uiElements.btns[id];
        // 若已存在也更新 RobotType（避免配置變更時不生效）
        if (mGameBtns[id]) mGameBtns[id].RobotType = type;
      }

      element.style.position = "absolute";
      element.style.left = `${pos[0] * boundary.scaleX}px`;
      element.style.top = `${pos[1] * boundary.scaleY}px`;
      element.style.width = `${uiSize[0] * boundary.scaleX}px`;
      element.style.height = `${uiSize[1] * boundary.scaleY}px`;
    }

    if (AppCtrl.isRobotMode()) {
      startRobotAutoPlay();
    }
  }

  function fit() {
    //const win = $(window),
    const win = window;
    const winWidth = win.screen.width;
    const winHeight = win.screen.height;
    const winScale = winWidth / winHeight;

    //page = $('.page');
    const page = document.createElement("page");

    const pageWidth = 640;
    const pageHeight = 1080;
    const pageScale = pageWidth / pageHeight;

    const origin = "50% 50% 0";
    let initialScale;
    if (winScale > pageScale) {
      initialScale = winWidth / pageWidth;
    } else {
      initialScale = winHeight / pageHeight;
    }
    //ScaleW = initialScale;

    page.style["width"] = pageWidth;
    page.style["height"] = pageHeight;
    page.style["-webkit-transform"] = "scale(" + initialScale + ")";
    page.style["transform"] = "scale(" + initialScale + ")";
    page.style["-webkit-transform-origin"] = origin;
    page.style["transform-origin"] = origin;
    page.style["margin-left"] = (pageWidth - winWidth) / -2 + "px";
    page.style["margin-top"] = (pageHeight - winHeight) / -2 + "px";
    /*
        page.css({
            'width' : pageWidth,
            'height' : pageHeight,
            '-webkit-transform' : 'scale(' + initialScale + ')',
            'transform' : 'scale(' + initialScale + ')',
            '-webkit-transform-origin' : origin,
            'transform-origin' : origin,
            'margin-left' : (pageWidth - winWidth) / -2 + 'px',
            'margin-top' : (pageHeight - winHeight) / -2 + 'px'
        })
        */
  }
  function buildGameUI(deviceWidth, deviceHeight, uiConfig) {
    const uiMainArea = document.getElementById("mainArea");
    // if config exists, do layout
    if (uiConfig) {
      const folderName = uiConfig.hasOwnProperty("foldername")
        ? uiConfig["foldername"]
        : "huga";
      const machine = uiConfig["machine"];
      const gameothers = uiConfig["gameothers"];
      const gamebtns = uiConfig["gamebtns"];
      let fullscreen = false;

      if (uiConfig.hasOwnProperty("fullscreen")) {
        fullscreen = true;
      }

      let logicUIWidth;
      let logicUIHeight;
      let realUIWidth;
      let realUIHeight;
      let wScale;
      let hScale;

      if (uiConfig.hasOwnProperty("size")) {
        const uiSize = uiConfig["size"].split(",");
        logicUIWidth = uiSize[0];
        logicUIHeight = uiSize[1];
      } else {
        logicUIWidth = 1920;
        logicUIHeight = 1080;
      }

      const ratioScreen = deviceWidth / deviceHeight;
      const ratioUI = logicUIWidth / logicUIHeight;
      if (ratioScreen > ratioUI) {
        // keep blank at left & right
        realUIHeight = deviceHeight;
        if (fullscreen) realUIWidth = realUIHeight * ratioScreen;
        else realUIWidth = realUIHeight * ratioUI;

        console.log("realUIWidth", realUIWidth, "realUIHeight", realUIHeight);
      } else {
        // keep blank at top & bottom
        realUIWidth = deviceWidth;
        if (fullscreen) realUIHeight = realUIWidth / ratioScreen;
        else realUIHeight = realUIWidth / ratioUI;
      }
      wScale = realUIWidth / logicUIWidth;
      hScale = realUIHeight / logicUIHeight;
      setWScale(wScale);
      setHScale(hScale);

      if (uiMainArea) {
        const win = window;
        const winWidth = win.screen.width;
        const winHeight = win.screen.height;
        const winScale = winWidth / winHeight;

        const pageWidth = 1920;
        const pageHeight = 1080;
        const pageScale = pageWidth / pageHeight;

        const origin = "50% 50% 0";
        let initialScale = 1;
        if (winScale > pageScale) {
          initialScale = winWidth / pageWidth;
        } else {
          initialScale = winHeight / pageHeight;
        }
        // if(fullscreen)
        //     ScaleW = initialScale;

        const boundary = {
          x: (deviceWidth - realUIWidth) / 2,
          y: (deviceHeight - realUIHeight) / 2,
          w: realUIWidth,
          h: realUIHeight,
          scaleX: wScale,
          scaleY: hScale,
        };
        uiMainArea.style.left = `${boundary.x}px`;
        uiMainArea.style.top = `${boundary.y}px`;
        uiMainArea.style.width = `${boundary.w}px`;
        uiMainArea.style.height = `${boundary.h}px`;
        uiMainArea.style.display = "";

        if (machine) setMachine(machine, boundary, folderName);
        if (gameothers)
          setGameOthers(gameothers, boundary, folderName, uiMainArea);
        if (gamebtns) setGameBtns(gamebtns, boundary, folderName, uiMainArea);
      }
      console.log(`buildGameUI`);
    } else {
      if (uiMainArea) uiMainArea.style.display = "none";
    }
  }

  function onOtherBtnDown(e) {
    const bMobileDevice = Utils.detectmob();
    if (bMobileDevice) {
      //預防常壓按鈕後跳出下載圖片事件
      e.preventDefault();
    }
  }

  function registerEvent() {
    // trigger onResize to do layout
    window.addEventListener("resize", onResize);

    setTimeout(function () {
      const uiLoadingMask = document.getElementById("loadingmask");
      const uiUnMountHint = document.getElementById("unMountHint");
      if (uiLoadingMask) uiLoadingMask.style.display = "none";
      if (uiUnMountHint) uiUnMountHint.style.display = "none";
      if (mHereAnimation) {
        mHereAnimation.style.display = "";
        setTimeout(function () {
          mHereAnimation.style.display = "none";
        }, 9500);
      }
      if (mTianjing) {
        mTianjing.style.display = "";
      }
    }, 4000);

    const bMobileDevice = Utils.detectmob();
    for (let key in mGameBtns) {
      const gameBtn = mGameBtns[key];
      //
      if (bMobileDevice) {
        gameBtn.btn.addEventListener("touchstart", onGameBtnDown);
        gameBtn.btn.addEventListener("touchend", onGameBtnUp);
      } else {
        gameBtn.btn.addEventListener("mousedown", onGameBtnDown);
        gameBtn.btn.addEventListener("mouseup", onGameBtnUp);
        if(Config?.logingFromMachine === true)
        {
          gameBtn.btn.addEventListener("touchstart", onGameBtnDown);
          gameBtn.btn.addEventListener("touchend", onGameBtnUp);
        }
        
      }
    }

    for (let key1 in mGameOthers) {
      const otherBtn = mGameOthers[key1];
      const eventID = otherBtn.btnEvent;
      if (eventID != "none") {
        if (bMobileDevice) {
          otherBtn.btn.addEventListener("touchstart", eval(eventID));
        } else {
          otherBtn.btn.addEventListener("mousedown", eval(eventID));
        }
      }
    }

    const bgelement = document.getElementById(bgImgId);
    if (bMobileDevice) {
      if (bgelement) bgelement.addEventListener("touchstart", onOtherBtnDown);
    } else {
      if (bgelement) bgelement.addEventListener("mousedown", onOtherBtnDown);
    }

    if (!bMobileDevice && isKeyboardEnable) {
      document.addEventListener("keydown", onGameBtnDown);
      document.addEventListener("keyup", onGameBtnUp);
      document.addEventListener("keydown", KeyboardDown);
    }
  }

  function unregisterEvent() {
    window.removeEventListener("resize", onResize);

    // clear long pressed event
    const bMobileDevice = Utils.detectmob();
    for (let key in mGameBtns) {
      const gameBtn = mGameBtns[key];
      if (gameBtn.pinponTimer) {
        clearInterval(gameBtn.pinponTimer);
        gameBtn.pinponTimer = null;
      }
      //
      if (bMobileDevice) {
        gameBtn.btn.removeEventListener("touchstart", onGameBtnDown);
        gameBtn.btn.removeEventListener("touchend", onGameBtnUp);
      } else {
        gameBtn.btn.removeEventListener("mousedown", onGameBtnDown);
        gameBtn.btn.removeEventListener("mouseup", onGameBtnUp);
        if(Config?.logingFromMachine === true)
        {
          gameBtn.btn.removeEventListener("touchstart", onGameBtnDown);
          gameBtn.btn.removeEventListener("touchend", onGameBtnUp);
        }
        
      }
      delete mGameBtns[key];
    }

    for (let key1 in mGameOthers) {
      const otherBtn = mGameOthers[key1];
      const eventID = otherBtn.btnEvent;
      if (eventID != "none") {
        if (bMobileDevice) {
          otherBtn.btn.removeEventListener("touchstart", eval(eventID));
        } else {
          otherBtn.btn.removeEventListener("mousedown", eval(eventID));
        }
      }
      delete mGameOthers[key1];
    }

    const bgelement = document.getElementById(bgImgId);
    if (bMobileDevice) {
      if (bgelement)
        bgelement.removeEventListener("touchstart", onOtherBtnDown);
    } else {
      if (bgelement) bgelement.removeEventListener("mousedown", onOtherBtnDown);
    }

    if (!bMobileDevice && isKeyboardEnable) {
      document.removeEventListener("keydown", onGameBtnDown);
      document.removeEventListener("keyup", onGameBtnUp);
      document.removeEventListener("keydown", KeyboardDown);
    }
    const uiMainArea = document.getElementById("mainArea");
    if (!uiMainArea) return;
    const uiloadingmask = document.getElementById("loadingmask");
    if (uiloadingmask) uiMainArea.removeChild(uiloadingmask);
    const uiUnMountHint = document.getElementById("unMountHint");
    if (uiUnMountHint) uiMainArea.removeChild(uiUnMountHint);
  }
  function decryptByDESModeEBC(ciphertext) {
    const keyHex = CryptoJS.enc.Utf8.parse("95279527");
    const decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(ciphertext),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  function decryptByDESModeCBC(ciphertext2) {
    const keyHex = CryptoJS.enc.Utf8.parse("95279527");
    const ivHex = CryptoJS.enc.Utf8.parse("95279527");
    // direct decrypt ciphertext
    const decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(ciphertext2),
      },
      keyHex,
      {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  function startVideo(uiIndex, videoSource, videoAngle) {
    const gameVideoId = videoIds[uiIndex].iframe;
    const uiGameVideo = document.getElementById(gameVideoId);

    if (uiGameVideo) {
      let url = "";
      const keyWord = "?VideoName=://";
      let index = videoSource.indexOf(keyWord);
      if (index >= 0) {
        videoSource = videoSource.substr(index + keyWord.length);

        const strParams = videoSource.split("/");
        index = strParams[0].indexOf(":");
        const videoDomain =
          index >= 0 ? strParams[0].substr(0, index) : strParams[0];
        let videoId;
        let sVideoId;
        if (AppCtrl.strEncrypt() === true) {
          var ciphertext = strParams[strParams.length - 1];
          sVideoId = strParams[strParams.length - 1];
          var sData = decryptByDESModeCBC(ciphertext);
          console.log(sData);
        } else {
          sVideoId = strParams[strParams.length - 1];
          videoId = parseInt(sVideoId);
        }

        if (videoDomain.toLowerCase() == "www.hzlive.com.tw") {
          let url = `https://${videoDomain}`;
          for (let i = 1; i < strParams.length - 1; i++) {
            url += `/${strParams[i]}`;
          }
        } else {
          //url = `http://${videoDomain}/?id=${videoId}&controls=0&autostart=true&muted=true`;
          url = `${protocolRef.current}://${videoDomain}/?id=${sVideoId}&autostart=true&muted=true`;
        }
        videoInfo[uiIndex].streamId = videoId;
      } else {
        url = videoSource;
        videoInfo[uiIndex].streamId = uiIndex;
      }

      const account = AppCtrl.getAccount();
      const machineToken = AppCtrl.getMachineToken();
      const connectionId = AppCtrl.middleServer().connectionId();
      const lobby = AppCtrl.lobbyName();

      if (machineToken)
        url += `&token=${machineToken}&account=${account}&connectionId=${connectionId}&lobby=${lobby}`;

      uiGameVideo.src = url;
      uiGameVideo.style.display = "";
      uiGameVideo.style.objectFit = "fill";
      //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

      uiGameVideo.setAttribute("playsinline", null);
      uiGameVideo.setAttribute("WebKitPlaysInline", null);
      //uiGameVideo.controls = "controls";
      //uiGameVideo.controls = "false";
      uiGameVideo.autoplay = "autoplay";
      uiGameVideo.WebKitPlaysInline = true;
      uiGameVideo.playsinline = true;
      uiGameVideo.preload = "auto";
      uiGameVideo.muted = "true";

      //////////////////////////////////
      //畫面旋轉部分
      //uiGameVideo.style.transform = `rotate(${videoAngle}deg)`;
      if (uiIndex === 0) {
        const checkOrientation = AppCtrl.CheckOrientation();
        if (checkOrientation) {
          if (videoAngle != 0 && videoAngle != 180) {
            AppCtrl.LandscapePortraitSet(ScreenOrientation.PortraitPrimary);
          } else {
            AppCtrl.LandscapePortraitSet(ScreenOrientation.LandscapePrimary);
          }
        }
      }
      ////////////////////////////
    }
  }

  function stopVideo(uiIndex) {
    const gameVideoId = videoIds[uiIndex].iframe;
    const uiGameVideo = document.getElementById(gameVideoId);
    if (uiGameVideo) {
      uiGameVideo.src = "";
      uiGameVideo.style.display = "none";
    }
  }

  function displayElement(Display) {
    for (let key1 in mGameOthers) {
      const otherBtn = mGameOthers[key1];
      const ElementID = otherBtn.btnID;

      if (
        ElementID !== "exit" &&
        ElementID !== "popscreen" &&
        ElementID != "screen" &&
        ElementID != "screen1" &&
        ElementID != "screen2" &&
        ElementID != "machinetitle"
      ) {
        const uiElement = document.getElementById(ElementID);
        if (uiElement) uiElement.hidden = !Display;
      }
    }

    for (let key in mGameBtns) {
      const gameBtn = mGameBtns[key];
      const ElementID = gameBtn.btnID;
      const uiElement = document.getElementById(ElementID);
      if (uiElement) uiElement.hidden = !Display;
    }
  }

  function popScreen(e) {
    // switch mVideoUIIndex
    if (mMSDisplayIndex != 2) mMSDisplayIndex = 2;
    else mMSDisplayIndex = 0;
    if (mMSDisplayIndex === 2) {
      displayElement(false);
      const uiView0 = document.getElementById(videoIds[0].id);
      uiView0.hidden = true;
      const uiView1 = document.getElementById(videoIds[1].id);
      uiView1.hidden = true;
      const uiView2 = document.getElementById(videoIds[2].id);
      uiView2.hidden = false;
      const uiExit = document.getElementById("exit");
      if (uiExit) uiExit.style.opacity = 0.3;
      const uiPopscreen = document.getElementById("popscreen");
      if (uiPopscreen) uiPopscreen.style.opacity = 0.3;
    } else {
      displayElement(true);
      const uiView0 = document.getElementById(videoIds[0].id);
      uiView0.hidden = false;
      const uiView1 = document.getElementById(videoIds[1].id);
      uiView1.hidden = false;
      const uiView2 = document.getElementById(videoIds[2].id);
      uiView2.hidden = true;
      const uiExit = document.getElementById("exit");
      if (uiExit) uiExit.style.opacity = 1.0;
      const uiPopscreen = document.getElementById("popscreen");
      if (uiPopscreen) uiPopscreen.style.opacity = 1.0;
    }
  }

  function mainView() {
    // 快速回到原來的視窗排列
    const uiIndex = mVideoUIIndex;
    // switch to original view layout
    for (let i = uiIndex; i < mVideoUINum; i++) {
      switchView();
    }
  }

  function TurnView() {
    mVideoUIIndex++;
    if (mVideoUIIndex >= mVideoUINum) mVideoUIIndex = 0;
    for (let i = 0; i < mVideoUINum; i++) {
      const uiView = document.getElementById(videoIds[i].id);
      if (uiView) uiView.hidden = i === mVideoUIIndex ? false : true;
    }
  }

  function switchView() {
    // switch mVideoUIIndex
    mVideoUIIndex = (mVideoUIIndex + 1) % mVideoUINum;

    const bounds = [];
    for (let i = 0; i < mVideoUINum; i++) {
      const index = (i + 1) % mVideoUINum;
      const uiView = document.getElementById(videoIds[index].id);
      bounds.push({
        left: uiView.style.left,
        top: uiView.style.top,
        width: uiView.style.width,
        height: uiView.style.height,
      });
    }
    for (let i = 0; i < mVideoUINum; i++) {
      const uiView = document.getElementById(videoIds[i].id);
      uiView.style.left = bounds[i].left;
      uiView.style.top = bounds[i].top;
      uiView.style.width = bounds[i].width;
      uiView.style.height = bounds[i].height;
    }
  }

  let isFullScreen = false;
  function fullscreen(e) {
    isFullScreen = !isFullScreen;
    Utils.enterFullScreen();
    /*
        if (isFullScreen == true) {
            Utils.enterFullScreen();
        }
        else {
            Utils.exitFullScreen();
        }
        */
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
  }

  function KeyboardDown(e) {
    e.preventDefault();
    let btnId = null;
    let gameOtherBtn;
    if (e.type == "keydown") {
      const key = e.key;

      for (let id in mGameOthers) {
        gameOtherBtn = mGameOthers[id];
        if (key == gameOtherBtn.Keyboard) {
          btnId = id;
          break;
        }
      }
      if (btnId === null || !gameOtherBtn) return;

      console.log("exit-Keyboard");
      console.log(`key=${e}.key},code=${e.code}`);

      switch (btnId) {
        case "exit":
          exit(e);
          break;
        case "popscreen":
          popScreen(e);
          break;
        case "view":
          switchView(e);
          break;
        case "mainview":
          mainView(e);
          break;
        case "fullscreen":
          fullscreen(e);
          break;
        case "reload":
          doReload();
          break;
        case "restart":
          doRestart();
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className={styles.gamePlayClassic}>
      {/* 右上角顯示自動退出倒數 */}
      {AppCtrl.isRobotMode() && robotExitCountdown !== null && (
        <div
          style={{
            position: "fixed",
            right: "8px",
            top: "8px",
            zIndex: 9999,
            color: "#fff",
            background: "rgba(0,0,0,0.6)",
            padding: "6px 10px",
            borderRadius: "4px",
            fontWeight: "bold",
            pointerEvents: "none",
          }}
        >
          自動退出倒數: {formatCountdown(robotExitCountdown)}
        </div>
      )}
      <div id="mainArea" className={styles.mainArea}>
        <GameBG bgImgId={bgImgId} />
        <VideoPanel info={videoIds[0]} />
        <VideoPanel info={videoIds[1]} />
        <VideoPanel info={videoIds[2]} />
        <div id="panelbetwin">
          {Object.values(betWinData).length > 0 ? <BetWinPanel /> : null}
        </div>
      </div>
    </div>
  );
}

export default GamePlayClassic;
